import { type MutableRefObject, useRef, useState } from 'react';

const CLICK_SUPPRESS_THRESHOLD_PX = 5;

export function useScrollHorizontal(externalRef?: MutableRefObject<HTMLDivElement | null>) {
  const internalRef = useRef<HTMLDivElement>(null);
  const containerRef = externalRef ?? internalRef;
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const hasDraggedRef = useRef(false);
  // 마우스 이벤트 핸들러
  const handleMouseDown = (e: React.MouseEvent) => {
    hasDraggedRef.current = false;
    setIsDragging(true);
    setStartX(e.pageX - (containerRef.current?.offsetLeft || 0));
    setScrollLeft(containerRef.current?.scrollLeft || 0);
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - (containerRef.current?.offsetLeft || 0);
    const walk = (x - startX) * 1; // 드래그 속도 조절 (1은 기본값)
    if (Math.abs(walk) > CLICK_SUPPRESS_THRESHOLD_PX) hasDraggedRef.current = true;
    if (containerRef.current) {
      containerRef.current.scrollLeft = scrollLeft - walk;
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // 끌리는 동안 항목이 커서와 함께 움직여, 놓은 자리의 같은 항목이 click 을 받는다.
  const handleClickCapture = (e: React.MouseEvent) => {
    if (!hasDraggedRef.current) return;
    hasDraggedRef.current = false;
    e.preventDefault();
    e.stopPropagation();
  };

  // 터치 이벤트 핸들러
  const handleTouchStart = (e: React.TouchEvent) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX - (containerRef.current?.offsetLeft || 0));
    setScrollLeft(containerRef.current?.scrollLeft || 0);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (!isDragging) return;
    const x = e.touches[0].pageX - (containerRef.current?.offsetLeft || 0);
    const walk = (x - startX) * 1;
    if (containerRef.current) {
      containerRef.current.scrollLeft = scrollLeft - walk;
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  return {
    containerRef,
    handleMouseDown,
    handleMouseMove,
    handleMouseUp,
    handleClickCapture,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
  };
}
